import {
  CheckMetadata,
  createSimpleCheckMetadataArray,
} from 'dashboard/components/ChecksTable/computeCheckMetadata';
import { IdAgeComparison } from 'dashboard/models/check';

export const computeIdAgeComparisonMetadata = (check: IdAgeComparison): CheckMetadata => {
  const { age } = check.metadata || {};

  return {
    metadata: createSimpleCheckMetadataArray([
      {
        label: 'Age',
        value: age ? Math.trunc(age) + ' years old' : '-',
      },
    ]),
    hideIfVerificationPassed: false,
  };
};
